import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';

@Component({
  selector: 'app-edit-facility',
  templateUrl: './edit-facility.component.html',
  styleUrls: ['./edit-facility.component.css']
})
export class EditFacilityComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private router: Router,
    private routeActive: ActivatedRoute
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("LLEGO A INSTALACION");
    var data = this.routeActive.snapshot.params;
    this.dataId = data['id'];
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/instalaciones/gestion']);
    }
  }
  ngOnInit(): void {
    console.log("LLEGO A BODEGA");
    var data = this.routeActive.snapshot.params;
    this.getFacility();
    this.dataId = data['id'];
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/instalaciones/gestion']);
    }
  }

  @Input()
  template: string;
  @Input()
  dataId: number = 0;

  @Input()
  modalRef: NgbModalRef | undefined;

  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Clients>();
  id: number = 0;
  active = 1;
  items: any;
  view: number = 1;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    image_path: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    content:new UntypedFormControl(''),
    private_content:new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
  });
  facilitys: Facility[];
  getClient(id: number) {
    this.api.getFacility(id).subscribe(
      (response) => {
        this.form.patchValue(response.data);
      },
      (error) => {
        this.toast.warning('', 'Instalación no encontrada');
        this.router.navigate(['/control-ingreso/instalaciones/gestion']);
      }
    );
  }
  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilitys = res.data as Facility[];
    });
  }
  update() {
    this.api.updateFacility(this.form).subscribe(
      (response) => {
        this.toast.success(
          response.msg,
          'Gestión Instalación  '
        );
        this.record.emit(response.data as Clients);
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error',{
          enableHtml:true,
          closeButton:true
        });
      }
    );
  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
    }
  }
  handleImageError() {
    this.form?.get('image_path').setValue('assets/images/default.jpg'); // Cambiar la URL a la imagen por defecto
  }
  openModal(md: any, size = 'md') {
    this.modalRef=this.modal.open(md, {
      size: size,
    });
  }
}
